import src from "IMAGE";
export default { src, width: 1600, height: 1200, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/webp;base64,UklGRlYAAABXRUJQVlA4TEoAAAAvB0ABAM1VICICHgjICQAAAIBbYQUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEEibmkcAACIiF5+Mh86OQjeyIZ/ekQ03Cg=="};
